<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M21.9949 4.82373C21.9037 3.24892 20.5977 2 19 2H5L4.82373 2.00509C3.24892 2.09634 2 3.40232 2 5V15L2.00509 15.1763C2.09634 16.7511 3.40232 18 5 18H9V16H5L4.88338 15.9933C4.38604 15.9355 4 15.5128 4 15V6H20V15L19.9933 15.1166C19.9355 15.614 19.5128 16 19 16H15V18H19L19.1763 17.9949C20.7511 17.9037 22 16.5977 22 15V5L21.9949 4.82373ZM12.079 8.002L12.082 8.003L11.9668 8.00055L11.8825 8.00683L11.734 8.03585L11.6583 8.05989L11.5769 8.09365L11.5159 8.12467L11.4047 8.19633L11.3369 8.2515L11.2929 8.29289L7.29289 12.2929L7.2097 12.3871C6.90468 12.7794 6.93241 13.3466 7.29289 13.7071L7.3871 13.7903C7.77939 14.0953 8.34662 14.0676 8.70711 13.7071L11 11.416V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V11.414L15.2929 13.7071L15.3871 13.7903C15.7794 14.0953 16.3466 14.0676 16.7071 13.7071C17.0976 13.3166 17.0976 12.6834 16.7071 12.2929L12.7071 8.29289L12.5952 8.19631L12.5207 8.146L12.4232 8.09367L12.3417 8.05989L12.2335 8.02742L12.079 8.002Z"
    fill="currentColor"
  />
</svg>
